// register start banner resources
import RegisterStartBanner3MoCenterBg from "@/assets/images/banner3/register-start/mo_c.png"
import RegisterStartBanner3MoLeftBg from "@/assets/images/banner3/register-start/mo_l.png"
import RegisterStartBanner3MoRightBg from "@/assets/images/banner3/register-start/mo_r.png"
import RegisterStartBanner3PcCenterBg from "@/assets/images/banner3/register-start/pc_c.png"
import RegisterStartBanner3PcLeftBg from "@/assets/images/banner3/register-start/pc_l.png"
import RegisterStartBanner3PcRightBg from "@/assets/images/banner3/register-start/pc_r.png"

// register end banner resources
import RegisterEndBanner3MoEnCenterBg from "@/assets/images/banner3/register-end/mo_en_c.png"
import RegisterEndBanner3MoEnLeftBg from "@/assets/images/banner3/register-end/mo_en_l.png"
import RegisterEndBanner3MoEnRightBg from "@/assets/images/banner3/register-end/mo_en_r.png"
import RegisterEndBanner3MoKoCenterBg from "@/assets/images/banner3/register-end/mo_ko_c.png"
import RegisterEndBanner3MoKoLeftBg from "@/assets/images/banner3/register-end/mo_ko_l.png"
import RegisterEndBanner3MoKoRightBg from "@/assets/images/banner3/register-end/mo_ko_r.png"
import RegisterEndBanner3PcCenterBg from "@/assets/images/banner3/register-end/pc_c.png"
import RegisterEndBanner3PcLeftBg from "@/assets/images/banner3/register-end/pc_l.png"
import RegisterEndBanner3PcRightBg from "@/assets/images/banner3/register-end/pc_r.png"

import { device_px, secondary } from "@/styles/variable"
import styled from "styled-components"

const { MAX_1919, MAX_1439, MAX_1279, MAX_767 } = device_px

export const Banner3Container = styled.div<{ $isEn: boolean }>`
  margin-top: ${({ $isEn }) => ($isEn ? "78px" : "32px")};

  &.upcoming-event {
    margin-top: -40px;
  }

  @media only screen and (max-width: ${MAX_1919}) {
    margin-top: ${({ $isEn }) => ($isEn ? "77px" : "35px")};

    &.upcoming-event {
      margin-top: 0;
    }
  }

  @media only screen and (max-width: ${MAX_1439}) {
    margin-top: ${({ $isEn }) => ($isEn ? "14px" : "8px")};
  }

  @media only screen and (max-width: ${MAX_1279}) {
    margin-top: ${({ $isEn }) => ($isEn ? "85px" : "70px")};
  }

  @media only screen and (max-width: ${MAX_767}) {
    margin-top: 60px;
    padding-top: ${({ $isEn }) => ($isEn ? "32px" : "0")};

    &.upcoming-event {
      padding-top: ${({ $isEn }) => ($isEn ? "60px" : "0")};
    }
  }
`

export const Banner3Wrapper = styled.div<{ $isEn: boolean }>`
  position: relative;
  margin: 0 -60px;
  height: 1100px;
  background: center / contain repeat-x url(${RegisterStartBanner3PcCenterBg});

  &::before,
  &::after {
    content: "";
    position: absolute;
    top: 0;
    height: 100%;
    aspect-ratio: 850 / 1100;
  }

  &::before {
    left: 0;
    background: center / cover no-repeat url(${RegisterStartBanner3PcLeftBg})
      black;
  }

  &::after {
    right: 0;
    background: center / cover no-repeat url(${RegisterStartBanner3PcRightBg})
      black;
  }

  &.upcoming-event {
    background: center / contain repeat-x url(${RegisterEndBanner3PcCenterBg});

    &::before {
      background: center / cover no-repeat url(${RegisterEndBanner3PcLeftBg})
        black;
    }

    &::after {
      background: center / cover no-repeat url(${RegisterEndBanner3PcRightBg})
        black;
    }
  }

  @media only screen and (max-width: ${MAX_1919}) {
    height: 825px;
  }

  @media only screen and (max-width: ${MAX_1439}) {
    height: 733px;
  }

  @media only screen and (max-width: ${MAX_1279}) {
    margin: 0 -30px;
    height: 440px;
  }

  @media only screen and (max-width: ${MAX_767}) {
    margin: 0;
    height: ${({ $isEn }) => ($isEn ? "359px" : "359px")};
    background: center / contain repeat-x url(${RegisterStartBanner3MoCenterBg});

    &::before,
    &::after {
      aspect-ratio: 290 / 652;
    }

    &::before {
      background: center / contain no-repeat
        url(${RegisterStartBanner3MoLeftBg}) black;
    }

    &::after {
      background: center / contain no-repeat
        url(${RegisterStartBanner3MoRightBg}) black;
    }

    &.upcoming-event {
      margin: ${({ $isEn }) => ($isEn ? "0 -11px" : "0")};
      height: 322px;
      background: ${({ $isEn }) =>
        `center / contain repeat-x url(${$isEn ? RegisterEndBanner3MoEnCenterBg : RegisterEndBanner3MoKoCenterBg})`};

      &::before {
        background: ${({ $isEn }) =>
          `center / contain no-repeat url(${$isEn ? RegisterEndBanner3MoEnLeftBg : RegisterEndBanner3MoKoLeftBg}) black`};
      }

      &::after {
        background: ${({ $isEn }) =>
          `center / contain no-repeat url(${$isEn ? RegisterEndBanner3MoEnRightBg : RegisterEndBanner3MoKoRightBg}) black`};
      }
    }
  }
`

export const Banner3Content = styled.div<{ $isEn: boolean }>`
  position: absolute;
  top: ${({ $isEn }) => ($isEn ? "126px" : "170px")};
  left: 50%;
  z-index: 3;
  transform: translateX(-50%);

  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;

  &.upcoming-event {
    top: ${({ $isEn }) => ($isEn ? "260px" : "280px")};
  }

  @media only screen and (max-width: ${MAX_1919}) {
    top: ${({ $isEn }) => ($isEn ? "78px" : "109px")};

    &.upcoming-event {
      top: ${({ $isEn }) => ($isEn ? "180px" : "200px")};
    }
  }

  @media only screen and (max-width: ${MAX_1439}) {
    top: ${({ $isEn }) => ($isEn ? "80px" : "109px")};

    &.upcoming-event {
      top: ${({ $isEn }) => ($isEn ? "168px" : "184px")};
    }
  }

  @media only screen and (max-width: ${MAX_1279}) {
    top: ${({ $isEn }) => ($isEn ? "14px" : "37px")};

    &.upcoming-event {
      top: ${({ $isEn }) => ($isEn ? "63px" : "75px")};
    }
  }

  @media only screen and (max-width: ${MAX_767}) {
    width: 100%;
    top: ${({ $isEn }) => ($isEn ? "-32px" : "21px")};

    &.upcoming-event {
      top: ${({ $isEn }) => ($isEn ? "8px" : "48px")};
    }
  }
`

export const Title = styled.h3`
  font-size: 50px;
  font-weight: 700;
  line-height: 120%;
  letter-spacing: -1.5px;

  @media only screen and (max-width: ${MAX_1919}) {
    font-size: 38px;
    letter-spacing: -1.14px;
  }

  @media only screen and (max-width: ${MAX_1279}) {
    font-size: 26px;
    letter-spacing: -0.78px;
  }

  @media only screen and (max-width: ${MAX_767}) {
    font-size: 24px;
    letter-spacing: -0.72px;

    &.en {
      max-width: 280px;
    }

    &.upcoming-event.en {
      max-width: 260px;
    }
  }
`

export const Description = styled.div<{ $isEn: boolean }>`
  margin-top: 40px;
  max-width: 100%;
  white-space: pre-wrap;
  font-size: 28px;
  font-weight: 500;
  line-height: 160%;
  letter-spacing: -0.84px;

  span {
    font-weight: 700;
    color: ${secondary.text};
  }

  @media only screen and (max-width: ${MAX_1919}) {
    margin-top: 30px;
    font-size: 20px;
    letter-spacing: -0.6px;
  }

  @media only screen and (max-width: ${MAX_1439}) {
    margin-top: 20px;
    font-size: 18px;
    font-weight: 400;
    letter-spacing: -0.54px;
  }

  @media only screen and (max-width: ${MAX_1279}) {
    font-size: 14px;
    font-weight: 500;
    line-height: 165%;
    letter-spacing: -0.42px;
  }
`

export const Note = styled.div<{ $isEn: boolean }>`
  margin-top: 20px;
  color: rgba(255, 255, 255, 0.4);

  text-align: center;
  font-size: 18px;
  font-weight: 400;
  line-height: 160%;
  letter-spacing: -0.54px;

  &::before {
    display: inline-block;
    content: "";
    margin: 0 7px 4px 0;

    border-radius: 50%;
    width: 4px;
    height: 4px;
    background-color: rgba(255, 255, 255, 0.4);
  }

  span {
    color: rgba(255, 255, 255, 0.8);
  }

  @media only screen and (max-width: ${MAX_1919}) {
    font-weight: 500;
  }

  @media only screen and (max-width: ${MAX_1439}) {
    margin-top: 10px;
    font-size: 12px;
    line-height: 165%; /* 19.8px */
    letter-spacing: -0.36px;

    &::before {
      margin: 0 7px 2px 0;
      width: 3px;
      height: 3px;
    }
  }

  @media only screen and (max-width: ${MAX_767}) {
    margin-top: 20px;
    max-width: ${({ $isEn }) => ($isEn ? "265px" : "170px")};
    font-size: 10px;
    line-height: 160%; /* 16px */
    letter-spacing: -0.3px;
  }
`

export const ApplyBtn = styled.button<{
  $isEn: boolean
  $isUpcomingEvent: boolean
}>`
  position: relative;
  display: flex;
  align-items: center;
  margin-top: 103px;
  border: none;
  border-radius: 97px;
  padding: 29px 39px;

  color: ${secondary.text};
  background-color: black;
  box-shadow:
    0px -14px 20px 8px rgba(0, 151, 215, 0.1) inset,
    0px 8px 14px 8px rgba(255, 225, 0, 0.25) inset;

  font-size: 28px;
  font-weight: 700;
  line-height: 39px;
  letter-spacing: -0.84px;
  white-space: pre-line;

  cursor: ${({ $isUpcomingEvent }) =>
    $isUpcomingEvent ? "default" : "pointer"};
  user-select: none;

  svg {
    margin-left: 55px;
  }

  &::before {
    content: "";
    position: absolute;
    z-index: -1;
    top: -1px;
    left: -1px;
    right: -1px;
    bottom: -1px;
    border-radius: 99px;
    background-image: linear-gradient(to top, #9cc452, #fadd02);
  }

  &.upcoming-event {
    margin-top: 100px;

    &.en {
      padding: 29px 49px;
    }
  }

  @media only screen and (max-width: ${MAX_1919}) {
    margin-top: 73px;

    &.upcoming-event {
      margin-top: 80px;
      padding: 22px 29px 22px 34px;
      border-radius: 83px;

      &.en {
        padding: 22px 49px;
      }

      &::before {
        border-radius: 85px;
      }
    }
  }

  @media only screen and (max-width: ${MAX_1439}) {
    margin-top: 70px;
    border-radius: 82px;
    padding: 21px 29px 21px 33px;

    box-shadow:
      0px -10px 12px 0px rgba(0, 151, 215, 0.1) inset,
      0px 8px 14px -6px rgba(255, 225, 0, 0.44) inset;

    font-size: 24px;
    line-height: 40px;
    letter-spacing: -0.72px;

    svg {
      margin-left: 40px;
    }

    &::before {
      border-radius: 84px;
    }

    &.upcoming-event {
      margin-top: 60px;
      border-radius: 71px;
      padding: 21px 33px;
      line-height: 29px;

      &.en {
        padding: 21px 39px;
      }

      &::before {
        border-radius: 73px;
      }
    }
  }

  @media only screen and (max-width: ${MAX_1279}) {
    margin-top: 32px;
    border-radius: 54px;
    padding: 10px 19px;

    box-shadow:
      0px -4px 5px -3px rgba(0, 151, 215, 0.1) inset,
      0px 3px 6px -2px rgba(255, 225, 0, 0.44) inset;

    font-size: 16px;
    line-height: 34px;
    letter-spacing: -0.48px;

    svg {
      margin-left: 20px;
      width: 16px;
    }

    &::before {
      border-radius: 56px;
    }

    &.upcoming-event {
      border-radius: 58px;
      padding: 18px 23px;
      line-height: 22px;
      font-size: 14px;

      &.en {
        padding: 18px 29px;
      }

      &::before {
        border-radius: 60px;
      }
    }
  }

  @media only screen and (max-width: ${MAX_767}) {
    margin-top: 20px;
    border-radius: 46px;
    padding: 6px 23px;

    box-shadow:
      0px -2px 5px 0px rgba(0, 151, 215, 0.1) inset,
      0px 2px 4px 0px rgba(255, 225, 0, 0.5) inset;

    font-size: 14px;
    line-height: 34px;
    letter-spacing: -0.42px;

    &::before {
      border-radius: 48px;
    }

    &.upcoming-event {
      border-radius: 60px;
      padding: 9px 23px;
      max-width: 250px;
      line-height: 21px;
      font-size: 14px;

      &::before {
        border-radius: 62px;
      }

      &.en {
        border-radius: 70px;
        padding: 14px 23px;
        max-width: 334px;

        &::before {
          border-radius: 72px;
        }
      }
    }
  }
`
